import React from "react";
import { motion } from "framer-motion";

// Bannière de couverture du portail national — style STRICTEMENT identique à PageBanner
// des sites personnalisés : sous-titre clair en haut, TITRE en dessous en doré minuscule
// avec les traits (légèrement plus grand), bloc positionné dans le bas de la photo.
// Supporte une image unique (`image`) ou plusieurs images en rotation/fondu (`images`).
export function PortalBanner({ image, images, subtitle, title, testid = "portal-banner", subtitleWide = false, subtitleCalli = false, imagePos = "center" }) {
  const list = React.useMemo(() => {
    const arr = (Array.isArray(images) && images.length ? images : [image]).filter(Boolean);
    return arr.length ? arr : [image].filter(Boolean);
  }, [images, image]);

  const [idx, setIdx] = React.useState(0);
  React.useEffect(() => {
    if (list.length < 2) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % list.length), 6500);
    return () => clearInterval(t);
  }, [list.length]);

  return (
    <section className="relative w-full h-[42vh] min-h-[300px] max-h-[460px] overflow-hidden flex items-end justify-center text-center" data-testid={testid}>
      {list.map((src, i) => (
        <div
          key={`${i}-${src}`}
          className={`absolute inset-0 bg-cover ${i === idx ? "opacity-100" : "opacity-0"}`}
          style={{
            backgroundImage: `url(${src})`,
            backgroundPosition: imagePos,
            transform: i === idx ? "scale(1.07)" : "scale(1)",
            transition: "opacity 1400ms ease-in-out, transform 7000ms linear",
          }}
          data-testid={`${testid}-slide-${i}`}
        />
      ))}
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(5,5,5,0.3) 0%, rgba(5,5,5,0.74) 100%)" }} />
      <div className={`relative z-10 w-full ${subtitleWide ? "max-w-6xl" : "max-w-3xl"} mx-auto px-6 pb-12 sm:pb-16`}>
        <motion.div initial={{ opacity: 0, y: 22 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }} className="flex flex-col items-center">
          <div className={`flex items-end justify-center ${subtitleCalli ? "min-h-[4.5rem] sm:min-h-[6rem]" : "min-h-[3.5rem] sm:min-h-[4rem]"}`}>
            {subtitle && (
              subtitleCalli
                ? <p className="calli text-[#C19A6B] leading-[1.05] text-4xl sm:text-5xl drop-shadow-[0_2px_18px_rgba(0,0,0,0.5)]">{subtitle}</p>
                : <p className={`font-light text-white leading-snug ${subtitleWide ? "text-base sm:text-xl lg:text-[26px] max-w-none sm:whitespace-nowrap" : "text-lg sm:text-xl lg:text-2xl max-w-2xl"}`}>{subtitle}</p>
            )}
          </div>
          {title && (
            <span className="mt-4 text-base sm:text-lg font-normal lowercase tracking-[0.18em] text-[#C19A6B] inline-flex items-center gap-3">
              <span className="w-8 h-px bg-[#C19A6B] inline-block" />{title}<span className="w-8 h-px bg-[#C19A6B] inline-block" />
            </span>
          )}
        </motion.div>
      </div>
    </section>
  );
}
